import { createFileRoute } from "@tanstack/react-router";
import { CodexScreen } from "@ui/screens/CodexScreen";

export const Route = createFileRoute("/codex")({
  component: CodexScreen,
});
